import { useInstance } from '../../support/ioc/useInstance';
import { AnchorButton } from '../../components/button/AnchorButton.tsx';
import { IArticleKey, IntercomService } from './IntercomService.ts';

export const ArticleLink: React.FC<{ articleKey: IArticleKey, onClick?: () => void, children: React.ReactNode}> = ({ articleKey, onClick, children }) => {
    const intercom = useInstance(IntercomService);

    const handleClick = async () => {
        await intercom.displayArticle(articleKey);
        if (onClick) {
            onClick();
        }
    };

    return (
        <AnchorButton onClick={handleClick}>{children}</AnchorButton>
    );
};
